import React, { useState } from 'react';
import {
    Popover,
    Typography,
    Button,
    Grid,
    IconButton
} from '@material-ui/core';
import {Close} from '@material-ui/icons';

//css
import Styles from './styles';
const useStyles = Styles();

export default ({
    Children,
    anchororigin,
    transformorigin,
    popoverWidth,
    popoverPadding,
    btvariant,
    handlerCleanFilters,
    handlerAplicarFilters,
    btLabel
}) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <>
            <Button
                aria-describedby={id} 
                variant={btvariant || "contained"}
                color="primary" 
                onClick={handleClick}
            >
                {(btLabel == null) &&
                    'MAIS OPÇÕES DE BUSCA'
                }
                {!(btLabel == null) &&
                    btLabel
                }
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={anchororigin}
                transformOrigin={transformorigin}
                PaperProps={{
                    style: {
                        width: popoverWidth,
                        padding: popoverPadding
                    },
                }}
            >
                <Grid
                    container
                    spacing={0}
                >
                    <Grid item xs={11} className={classes.titleGrid} align={"center"}>
                        <Typography className={classes.typography}>
                            FILTROS DE BUSCA
                        </Typography>
                    </Grid>
                    <Grid item xs={1} align={"right"}>
                        <IconButton
                            onClick={handleClose}
                        >
                            <Close/>
                        </IconButton>
                    </Grid>
                </Grid>
                
                <Children/>
                <Grid container spacing={0} className={classes.footer}>
                    <Grid item xs={8} className={classes.bt_footers}>
                        <Button
                            variant="outlined"
                            color="primary"
                            onClick={handlerCleanFilters}
                        >
                            LIMPAR FILTROS
                        </Button>
                    </Grid>
                    <Grid item xs={4} className={classes.bt_footers}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={()=>{
                                handleClose();
                                handlerAplicarFilters();
                            }}
                        >
                            APLICAR FILTROS
                        </Button>
                    </Grid>
                </Grid>
            </Popover>
        </>
    );
};
